import styled from "@emotion/styled";
import { TruckModalWrapper } from "../TruckStyles.styles";

export const TruckStopModalWrapper = styled(TruckModalWrapper)(({ theme }) => ({
	form: {
		"> div:last-of-type": {
			padding: "0 24px 24px 24px",
			display: "flex",
			flexDirection: "column",
			gap: "16px",
			"> span": {
				...theme.project.typography.body.body2,
				color: theme.project.colors.fontColors.secondary
			},
			"> div:first-of-type": {
				display: "flex",
				flexDirection: "column",
				gap: "8px",
				"> span": {
					...theme.project.typography.subtitle.subtitle2
				},
				"> div:nth-of-type(2)": {
					width: "100%",
					display: "flex",
					justifyContent: "flex-start",
					button: {
						with: 105,
						padding: 0,
						textDecoration: "underline"
					}
				}
			},
			"> div:last-of-type": {
				display: "flex",
				justifyContent: "space-between",
				gap: "16px",
				button: {
					flex: 1
				}
			},
			[theme.breakpoints.down("md")]: {
				"> div:last-of-type": {
					flexDirection: "column"
				}
			}
		}
	}
}));
